import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { NewLoanApplicationStore } from './../store/newLoanApplicationStore';

export const useNewLoanApplicationStore = () =>
  useContext<{
    newLoanApplicationStore: NewLoanApplicationStore;
  }>(StoreContext);
